import { Button } from '@/components/ui/button'
import { utmUtils } from '@/hooks/useUtmTracking'

const CTAButton = ({
  className = '',
  text = 'START YOUR CLAIM NOW',
  link = 'https://app.ycmcarfinanceclaims.co.uk/NewClaimantDetails/',
  disabled = false,
}) => {
  const handleClick = () => {
    if (disabled) return
    const urlWithUtms = utmUtils.createUrlWithUtms(link)
    window.open(urlWithUtms, '_blank')
  }

  return (
    <Button
      onClick={handleClick}
      className={`h-14 bg-[var(--brand-orange)] px-6 text-xl font-black text-white uppercase ${disabled ? 'cursor-default' : 'cursor-pointer'} ${className}`}
    >
      {text}
    </Button>
  )
}

export default CTAButton
